import Vue from 'vue'
import Router from 'vue-router'
const home = r => require.ensure([], () => r(require('../views/home')), 'home')
const home2021 = r =>
  require.ensure([], () => r(require('../views/home2021')), 'home2021')
const jskxdetail = r =>
  require.ensure([], () => r(require('../views/jskxdetail')), 'jskxdetail')
  const xzkxSchedule = r =>
  require.ensure([], () => r(require('../views/xzkxSchedule')), 'xzkxSchedule')
  const privacyPolicy = r =>
    require.ensure([], () => r(require('../views/privacyPolicy')), 'privacyPolicy')
const njkxdetail = r =>
  require.ensure([], () => r(require('../views/njkxdetail')), 'njkxdetail')
const szkxdetail = r =>
  require.ensure([], () => r(require('../views/szkxdetail')), 'szkxdetail')
const shortdetail = r =>
  require.ensure([], () => r(require('../views/shortdetail')), 'shortdetail')

const xuzhou05 = r =>
  require.ensure([], () => r(require('../views/xuzhou05')), 'xuzhou05')
const njjbxq = r =>
  require.ensure([], () => r(require('../views/njjbxq')), 'njjbxq')
const jssqsnkjzx = r =>
  require.ensure([], () => r(require('../views/jssqsnkjzx')), 'jssqsnkjzx')
const yckx = r =>
  require.ensure([], () => r(require('../views/yckx')), 'yckx')
const jbai = r =>
  require.ensure([], () => r(require('../views/jbai')), 'jbai')
const njjb = r =>
  require.ensure([], () => r(require('../views/njjb')), 'njjb')
const qxxxsy  = r =>
  require.ensure([], () => r(require('../views/qxsy')), 'qxsy')
const qxxxsyDetail = r =>
  require.ensure([], () => r(require('../views/qxxxsyDetail')), 'qxxxsyDetail')
const home2022 = r =>
  require.ensure([], () => r(require('../views/home2022')), 'home2022')
const tzkx = r =>
  require.ensure([], () => r(require('../views/tzkx')), 'tzkx')
const szkx = r =>
  require.ensure([], () => r(require('../views/szkx')), 'szkx')
const lygkx = r =>
  require.ensure([], () => r(require('../views/lygkx')), 'lygkx')
const introduction = r =>
  require.ensure([], () => r(require('../views/introduction')), 'introduction')
const latestNews = r =>
  require.ensure([], () => r(require('../views/latestNews')), 'latestNews')
const schoolCooperation = r =>
  require.ensure(
    [],
    () => r(require('../views/schoolCooperation')),
    'schoolCooperation'
  )
const cooperationMode = r =>
  require.ensure(
    [],
    () => r(require('../views/schoolCooperation/childViews/mode.vue')),
    'cooperationMode'
  )
const cooperationJoin = r =>
  require.ensure(
    [],
    () => r(require('../views/schoolCooperation/childViews/join.vue')),
    'cooperationJoin'
  )
const cooperationCase = r =>
  require.ensure(
    [],
    () => r(require('../views/schoolCooperation/childViews/case.vue')),
    'cooperationCase'
  )
const cooperationChannel = r =>
  require.ensure(
    [],
    () => r(require('../views/schoolCooperation/childViews/channel.vue')),
    'cooperationChannel'
  )
const cooperationSchool = r =>
  require.ensure(
    [],
    () => r(require('../views/schoolCooperation/childViews/school.vue')),
    'cooperationSchool'
  )
const notFound = r =>
  require.ensure([], () => r(require('../views/404')), 'notFound')
const community = r =>
  require.ensure([], () => r(require('../views/community')), 'community')
const artificialIntelligence = r =>
  require.ensure([], () => r(require('../views/community/artificialIntelligence.vue')), 'artificialIntelligence')
const hardware = r =>
  require.ensure([], () => r(require('../views/community/hardware.vue')), 'hardware')
const aiCoding = r =>
  require.ensure([], () => r(require('../views/community/aiCoding.vue')), 'aiCoding')
const software = r =>
  require.ensure([], () => r(require('../views/community/software.vue')), 'software')
const activity = r =>
  require.ensure(
    [],
    () => r(require('../views/activity/index.vue')),
    'activity'
  )
const works = r =>
  require.ensure([], () => r(require('../views/activity/works.vue')), 'works')
const firstChoice = r =>
  require.ensure(
    [],
    () => r(require('../views/activity/firstChoice.vue')),
    'firstChoice'
  )
const activity2020 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2020/index.vue')),
    'activity2020'
  )
const activity2021 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2021/index.vue')),
    'activity2021'
  )
const activity20210409 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity20210409/index.vue')),
    'activity20210409'
  )
const communityIndex = r =>
  require.ensure(
    [],
    () => r(require('../views/community/childViews/index.vue')),
    'communityIndex'
  )
const scratchProjects = r =>
  require.ensure(
    [],
    () => r(require('../views/scratch_projects')),
    'scratchProjects'
  )
const rankList = r =>
  require.ensure(
    [],
    () => r(require('../views/activity/rankList.vue')),
    'rankList'
  )
const works2020 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2020/works.vue')),
    'works2020'
  )
const firstChoice2020 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2020/firstChoice.vue')),
    'firstChoice2020'
  )
const rankList2020 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2020/rankList.vue')),
    'rankList2020'
  )
const works2021 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2021/works.vue')),
    'works2021'
  )
const firstChoice2021 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2021/firstChoice.vue')),
    'firstChoice2021'
  )
const rankList2021 = r =>
  require.ensure(
    [],
    () => r(require('../views/activity2021/rankList.vue')),
    'rankList2021'
  )
Vue.use(Router)

let router = new Router({
  mode: 'history',
  strict: process.env.NODE_ENV !== 'production',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/index',
      redirect: '/home'
    },
    {
      path: '/jskx',
      component: home2021
    },
    {
      path: '/jskxdetail',
      component: jskxdetail
    },
    {
      path: '/xzkxSchedule',
      component: xzkxSchedule
    },
    {
      path: '/privacyPolicy',
      component: privacyPolicy
    },
    {
      path: '/njkxdetail',
      component: njkxdetail
    },
    {
      path: '/szkxdetail',
      component: szkxdetail
    },
    {
      path: '/shortdetail',
      component: shortdetail
    },
    {
      path: '/njkx',
      component: home2022
    },
    {
      path: '/tzkx',
      component: tzkx
    },
    {
      path: '/szkx',
      component: szkx
    },
    {
      path: '/lygkx',
      component: lygkx
    },
    {
      path: '/xzkx',
      component: xuzhou05
    },
    {
      path: '/njjbxq',
      component: njjbxq
    },
    {
      path: '/qxxxsy',
      component: qxxxsy
    },
    {
      path: '/qxxxsyDetail',
      component: qxxxsyDetail
    },
    {
      path: '/yckx',
      component: yckx
    },
    {
      path: '/jbai',
      component: jbai
    },
    {
      path: '/njjb',
      component: njjb
    },
    {
      path: '/jssqsnkjzx',
      component: jssqsnkjzx
    },
    {
      path: '/home',
      component: home
    },
    {
      path: '/community',
      component: community
    },
    {
      path: '/community/artificialIntelligence',
      component: artificialIntelligence
    },
    {
      path: '/community/hardware',
      component: hardware
    },
    {
      path: '/community/aiCoding',
      component: aiCoding
    },
    {
      path: '/community/software',
      component: software
    },
    {
      path: '/community/index',
      component: communityIndex
    },
    {
      path: '/introduction',
      component: introduction
    },
    {
      path: '/latestNews',
      component: latestNews
    },
    {
      path: '/coop',
      component: schoolCooperation,
      children: [
        {
          path: 'mode', //  方式
          component: cooperationMode
        },
        {
          path: 'join', //  加盟
          component: cooperationJoin
        },
        {
          path: 'case', // 案例
          component: cooperationCase
        },
        {
          path: 'channel', //  渠道
          component: cooperationChannel
        },
        {
          path: 'school', //  渠道
          component: cooperationSchool
        }
      ]
    },
    {
      path: '/scratchProjects',
      component: scratchProjects
    },
    {
      path: '/activity',
      component: activity
    },
    {
      path: '/works',
      component: works
    },
    {
      path: '/firstChoice',
      component: firstChoice
    },
    {
      path: '/rankList',
      component: rankList
    },
    {
      path: '/activity2020',
      component: activity2020
    },
    {
      path: '/activity20210409',
      component: activity20210409
    },

    {
      path: '/activity2021',
      component: activity2021
    },
    {
      path: '/works2020',
      component: works2020
    },
    {
      path: '/firstChoice2020',
      component: firstChoice2020
    },
    {
      path: '/rankList2020',
      component: rankList2020
    },

    {
      path: '/works2021',
      component: works2021
    },
    {
      path: '/firstChoice2021',
      component: firstChoice2021
    },
    {
      path: '/rankList2021',
      component: rankList2021
    },
    {
      name: '404',
      path: '*',
      component: notFound
    }
  ]
})

// let token = getSessionStore('token') || getLocalStore('token')
// token && store.commit(SET_LOGIN, true)

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(r => r.meta.requireAuth)) {
//     if (store.state.isLogin || to.query.m === 's' || to.query.mode === 'preview') {
//       next()
//     } else {
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js